import { CSSObject } from '@chakra-ui/react';
import mascot from '@/assets/slambet/images/header/mascot.png';
import { CustomButtonProps } from '@/components/Button/Button';

export const BoxBallance: CSSObject = {
  bgGradient: 'linear(to-b, beta.500, beta.600)',
  borderX: '4px',
  borderColor: 'white',
  '> div:first-of-type': {
    color: 'alpha.400',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
  '> div:last-of-type': {
    color: 'white',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
};
export const buttonDepositProps: CustomButtonProps = {
  variant: 'solid',
  fontWeight: 'normal',
  w: 'full',
  mt: '2',
  sx: {
    '& svg': {
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
      mb: '1',
    },
  },
};
export const ButtonNavItem = (): CSSObject => ({
  bg: 'white',
  color: 'gray.700',
  borderTop: '1px',
  borderColor: 'gray.300',
  '&& > p': { transition: 'all 0.2s ease-in-out' },
  ':first-child': {
    borderTop: 'none',
  },
  '&:hover, &:active': {
    bg: 'alpha.300',
  },
});
export const BoxMascotImage: CSSObject = {
  bgImage: `url(${mascot})`,
  bgSize: '310px 100px',
  bgPos: 'inherit',
  bgRepeat: 'no-repeat',
  zIndex: '-1',
  display: ['none', null, null, null, 'block'],
  w: '40',
  h: '32',
  pos: 'absolute',
  top: '-6',
  left: '-1.5',
};
export const PopoverHeaderQA: CSSObject = {
  bg: 'beta.500',
  borderTop: '4px',
  borderX: '4px',
  borderColor: 'white',
  borderBottom: 'none',
  borderTopRadius: 'base',
  pb: '0',
  color: 'white',
  lineHeight: 'normal',
};
export const PopoverContentQA: CSSObject = {
  boxShadow: '2xl',
  top: -2,
  _focus: {
    boxShadow: '2xl',
  },
};
export const FlexBallanceItem: CSSObject = {
  color: 'white',
  p: {
    _last: { fontWeight: 'extrabold' },
  },
};
export const TextBalanceValue: CSSObject = {
  color: 'alpha.400',
  textShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  fontSize: 'sm',
  fontWeight: 'extrabold',
};
export const TextQuickAccessHello: CSSObject = {
  fontSize: 'sm',
};
export const buttonBalanceProps: CustomButtonProps = {
  variant: 'unstyled',
  display: 'flex',
  fontSize: 'sm',
  h: 'unset',
};
